export const IS_DEVELOPMENT_MODE =
  process.env.REACT_APP_ENV_MODE === 'uat' ||
  process.env.REACT_APP_ENV_MODE === 'dev' ||
  process.env.REACT_APP_ENV_MODE === 'local';
